/* eslint-disable */
import { Button } from "@chakra-ui/button";
import { FormControl, FormErrorMessage } from "@chakra-ui/form-control";
import { useToast } from "@chakra-ui/react";
import { Input, InputGroup,
  InputAddon,
  InputLeftAddon,
  InputRightAddon,
  InputElement,
  InputLeftElement,
  InputRightElement } from "@chakra-ui/input";
import { Box, Link, Text } from "@chakra-ui/layout";
import { Image } from "@chakra-ui/react";
import { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router";
import { registerUser, getCourses } from "../../redux/api_calls/apiCalls";
import { ReactComponent as Eye } from "../../svg/eye.svg";
import { ReactComponent as EyeSlash } from "../../svg/eyeSlash.svg";
import {
  Select,
  AsyncSelect,
  CreatableSelect,
  AsyncCreatableSelect,
} from "chakra-react-select";
import { Stack, HStack, VStack } from '@chakra-ui/react'

import PasswordInput from "../common/PasswordInput";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";

export default function Register() {
  const useYupValidationResolver = (validationSchema) =>
    useCallback(
      async (data) => {
        try {
          const values = await validationSchema.validate(data, {
            abortEarly: false,
          });

          return {
            values,
            errors: {},
          };
        } catch (errors) {
          console.log(errors);
          console.log(errors.inner);
          return {
            values: {},
            errors: errors.inner.reduce(
              (allErrors, currentError) => ({
                ...allErrors,
                [currentError.path]: {
                  type: currentError.type ?? "validation",
                  message: currentError.message,
                },
              }),
              {}
            ),
          };
        }
      },
      [validationSchema]
    );

  const validationSchema = yup.object({
    first_name: yup.string().required("First Name is required"),
    last_name: yup.string().required("Last Name is required"),
    email: yup.string().email("Not a valid email").required("Year is required"),
    phone: yup
      .number()
      .typeError("Not a valid phone number")
      .required("Mobile Number is required"),
    password: yup
      .string()
      .required("Password is required")
      .min(8, "Minimun 8 Character"),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password confirm is required"),
    subject_id: yup.array().required("Subject is required"),
  });

  const resolver = useYupValidationResolver(validationSchema);

  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({ resolver });

  const history = useHistory();
  const toast = useToast();

  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    const loadSubjects = async () => {
      let subjects = await getCourses();
      setSubjects(subjects);
    };
    loadSubjects();
  }, []);

  const onSubmit = async (val) => {
   
     const mobile_no = "+60"+"-"+val.phone;
      delete val.phone;
      console.log({...val, mobile_no});
    let fieldData = { ...val, mobile_no };   
    console.log(fieldData,"fieldData");
  try {
      let response = await registerUser(fieldData);
      if (response) {
        toast({
          title: "Registration Successful",
          description: "",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        history.push("/login");
      }
    } catch (error) {
      console.log({ error });
      toast({
        title: "Registration Failed!",
        description:
          error.response.data &&
          error.response.data.message &&
          error.response.data.message.mobile_no &&
          error.response.data.message.mobile_no.toString(),
        status: "error",
        duration: 10000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      w="100vw"
      minH="100vh"
      d="flex"
      justifyContent="center"
      alignItems="center"
      flexDir="column"
    >
      <Image
        src="./images/Logo.svg"
        width="300px"
        height="125px"
        objectFit="contain"
      />
      <Text
        fontSize={["16px", "22px", "26px", "30px"]}
        fontWeight="700"
        style={{ fontFamily: "Mulish, sans-serif" }}
        color="#222222"
        mb="2rem"
      >
        Tutor Sign Up
      </Text>

      <Box
        d="flex"
        justifyContent="center"
        alignItems="center"
        w={["95%", "90%", "70%", "60%", "45%"]}
      >
        <form
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            padding: "0px 1rem",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "1rem",
          }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <Box
            d="flex"
            width="100%"
            flexDir={["column", "column", "row", "row", "row"]}
            style={{ gap: "1rem" }}
          >
            <FormControl
              isInvalid={errors.first_name && errors.first_name.message}
            >
              <Input
                type="text"
                fontSize="16px"
                fontWeight="600"
                style={{ fontFamily: "Mulish, sans-serif" }}
                borderRadius="10px"
                h="40px"
                border="1px solid rgba(0, 0, 0, 0.1)"
                bg="#fcfcfc"
                id="firstName"
                placeholder="First Name"
                {...register("first_name")}
              />
              <FormErrorMessage>
                {errors.first_name && errors.first_name.message}
              </FormErrorMessage>
            </FormControl>

            <FormControl
              isInvalid={errors.last_name && errors.last_name.message}
            >
              <Input
                type="text"
                fontSize="16px"
                fontWeight="600"
                style={{ fontFamily: "Mulish, sans-serif" }}
                borderRadius="10px"
                h="40px"
                border="1px solid rgba(0, 0, 0, 0.1)"
                bg="#fcfcfc"
                id="lastName"
                placeholder="Last Name"
                {...register("last_name")}
              />
              <FormErrorMessage>
                {errors.last_name && errors.last_name.message}
              </FormErrorMessage>
            </FormControl>
          </Box>

          <FormControl isInvalid={errors.email && errors.email.message}>
            <Input
              type="email"
              fontSize="16px"
              fontWeight="600"
              style={{ fontFamily: "Mulish, sans-serif" }}
              borderRadius="10px"
              h="40px"
              border="1px solid rgba(0, 0, 0, 0.1)"
              bg="#fcfcfc"
              id="email"
              placeholder="Email Address"
              {...register("email")}
            />
            <FormErrorMessage>
              {errors.email && errors.email.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl isInvalid={errors.phone && errors.phone.message}>
              <InputGroup>
                <InputLeftAddon children='+60' />
                 <Input
                      type="number"
                      fontSize="16px"
                      fontWeight="600"
                      style={{ fontFamily: "Mulish, sans-serif" }}
                      borderRadius="10px"
                      h="40px"
                      border="1px solid rgba(0, 0, 0, 0.1)"
                      bg="#fcfcfc"
                      id="mobileNumber"
                      placeholder="Mobile Number"
                      {...register("phone")}
                    />
                    <FormErrorMessage>
                      {errors.phone && errors.phone.message}
                    </FormErrorMessage>
              </InputGroup>
               </FormControl>
          

          <FormControl
            isInvalid={errors.subject_id && errors.subject_id.message}
          >
            <Controller
              control={control}
              name="subject_id"
              render={({ field: { onChange } }) => (
                <Select
                  isMulti
                  border="1px solid rgba(0, 0, 0, 0.1)"
                  height="40px"
                  fontSize="18px"
                  placeholder="Subject"
                  onChange={(val) => {
                    let newValues = val.map((e) => e.value);
                    onChange(newValues);
                    return val;
                  }}
                  // name="subject_id"
                  options={subjects.map((e) => ({
                    label: e.name,
                    value: e.id.toString(),
                  }))}
                />
                // <Checkbox
                //   onBlur={onBlur} // notify when input is touched
                //   onChange={onChange} // send value to hook form
                //   checked={value}
                //   inputRef={ref}
                // />
              )}
            />

            {/* <Select
              
              
            >
              <option value="" disabled selected hidden>
                Select Subject
              </option>
              {subjects.map((item) => (
                <option value={item.id} id={item.id}>
                  {item.name}
                </option>
              ))}
            </Select> */}
            <FormErrorMessage fontSize="sm">
              {errors.subject_id && errors.subject_id.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.password && errors.password.message}>
            <PasswordInput
              name="password"
              register={register}
              fontSize="16px"
              fontWeight="600"
              style={{ fontFamily: "Mulish, sans-serif" }}
              borderRadius="10px"
              h="40px"
              border="1px solid rgba(0, 0, 0, 0.1)"
              bg="#fcfcfc"
              placeholder="Password"
            />
            <FormErrorMessage>
              {errors.password && errors.password.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl
            isInvalid={
              errors.password_confirmation &&
              errors.password_confirmation.message
            }
          >
            <PasswordInput
              name="password_confirmation"
              register={register}
              fontSize="16px"
              fontWeight="600"
              style={{ fontFamily: "Mulish, sans-serif" }}
              borderRadius="10px"
              h="40px"
              border="1px solid rgba(0, 0, 0, 0.1)"
              bg="#fcfcfc"
              placeholder="Confirm Password"
            />
            <FormErrorMessage>
              {errors.password_confirmation &&
                errors.password_confirmation.message}
            </FormErrorMessage>
          </FormControl>

          <Box d="flex" justifyContent="center" alignItems="center" w="100%">
            <Button
              mt={4}
              bg="linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)"
              _hover={{
                bg: "linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)",
              }}
              boxShadow="0px 4px 8px rgba(0, 0, 0, 0.1)"
              borderRadius="7px"
              loadingText="Registering..."
              isLoading={isSubmitting}
              fontSize="18px"
              fontWeight="900"
              style={{ fontFamily: "Mulish, sans-serif" }}
              color="#ffffff"
              type="submit"
              w="100%"
              h="40px"
            >
              Register
            </Button>
          </Box>
        </form>
      </Box>
      <Box
        d="flex"
        fontSize="16px"
        fontWeight="500"
        style={{ fontFamily: "Mulish, sans-serif" }}
        color="#222222"
        mt="1rem"
      >
        <Text mr="1">Already have an account?</Text>
        <Link href="/login">Log In</Link>
      </Box>
    </Box>
  );
}
